// Module
var code = "<svg :class=\"getClasses\" :viewBox=\"viewBox\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" version=\"1.1\"> <title v-if=\"title\">{{ title }}</title> <desc v-if=\"description\">{{ description }}</desc> <defs v-html=\"defs\"></defs> <g v-html=\"getGraphics\"></g> </svg> ";
// Exports
export default code;